var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataList && _vm.dataList.length)?_c('div',{staticClass:"option-comp"},[_c('ul',_vm._l((_vm.dataList),function(item,index){return _c('li',{key:index},[_c('el-button',{staticClass:"button-name",attrs:{"round":"","disabled":""}},[_vm._v(_vm._s(item))])],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }